export default __webpack_public_path__ + "static/media/client10.9baaf879.jpeg";